import React from 'react';
import {useGetCalculatorConfigQuery, useGetOfferQuery} from '../../../features/apiSlice';
import {useParams} from 'react-router-dom';
import ErrorIcon from '../../elements/Icons/ErrorIcon';
import {Col, Row} from 'react-bootstrap';
import PremiumAmountSum from '../../elements/Values/PremiumAmountSum';
import SmallSpinner from '../../elements/Spinner/SmallSpinner.jsx';
import PremiumAmount from "../../elements/Values/PremiumAmount.jsx";

const TravelAssistanceOfferInfoWidget = () => {
    const {
        offerId,
    } = useParams();

    const {
        data: offer,
        error,
        isSuccess,
        isError,
        isLoading,
    } = useGetOfferQuery(offerId, {
        skip: offerId === undefined,
    });

    const {
        data: calculatorConfig,
        isSuccess: calculatorConfigIsSuccess,
    } = useGetCalculatorConfigQuery();

    return (<>
        {isLoading && <SmallSpinner />}
        {isError && <ErrorIcon error={error} />}
        {isSuccess && <Row>
            {offer.insuranceCompanyReference && <>
                <Col sm={4} lg={12} xl={4} as="dt"><span className='text-red'>Допълнителна информация</span></Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <span className='text-red'>{offer.insuranceCompanyReference}</span>
                </Col>
            </>}
            {offer.insuranceCompany?.shortName && <>
                <Col sm={4} lg={12} xl={4} as="dt">Застрахователна компания</Col>
                <Col sm={8} lg={12} xl={8} as="dd">{offer.insuranceCompany?.shortName}</Col>
            </>}
            {offer.applicationTravelAssistance?.personalNumber && <>
                <Col sm={4} lg={12} xl={4} as="dt">Застраховащо лице</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    {offer.applicationTravelAssistance?.personalNumber}
                </Col>
            </>}
            {offer.applicationTravelAssistance?.insuredClientPins.length > 0 && <>
                <Col sm={4} lg={12} xl={4} as="dt">Застраховани лица</Col>
                <Col sm={8} lg={12} xl={8} as="dd">{''}</Col>
            </>
            }
            {offer.applicationTravelAssistance?.insuredClientPins.map(insuredClient =>
                <>
                    <Col sm={4} lg={12} xl={4} as="dt">{''}</Col>
                    <Col sm={8} lg={12} xl={8} as="dd">{insuredClient.insuredClientPin}</Col>
                </>
            )}
            <Col sm={4} lg={12} xl={4} as="dt">Мултитрип</Col>
            <Col sm={8} lg={12} xl={8} as="dd">{offer.applicationTravelAssistance?.isMultiTrip ? 'Да' : 'Не'}</Col>
            {offer.applicationTravelAssistance?.periodType && <>
                <Col sm={4} lg={12} xl={4} as="dt">Период</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    {offer.applicationTravelAssistance?.periodType} дни
                </Col>
            </>}
            {offer.applicationTravelAssistance?.destinationType && calculatorConfigIsSuccess &&<>
                <Col sm={4} lg={12} xl={4} as="dt">Дестинация</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    {calculatorConfig.travelDestinations[offer.applicationTravelAssistance?.destinationType]}
                </Col>
            </>}
            {offer.applicationTravelAssistance?.purposeType && calculatorConfigIsSuccess && <>
                <Col sm={4} lg={12} xl={4} as="dt">Цел на пътуването</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    {calculatorConfig.travelPurposes[offer.applicationTravelAssistance?.purposeType]}
                </Col>
            </>}
            {offer.applicationTravelAssistance?.medicalExpenses && <>
                <Col sm={4} lg={12} xl={4} as="dt">Медицински разноски</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmount amount={offer.applicationTravelAssistance?.medicalExpenses}/>
                </Col>
            </>}
            {offer.applicationTravelAssistance?.rescueCosts && <>
                <Col sm={4} lg={12} xl={4} as="dt">Спасителни разноски</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmount amount={offer.applicationTravelAssistance?.rescueCosts}/>
                </Col>
            </>}
            {offer.applicationTravelAssistance?.deathPermanentDisability && <>
                <Col sm={4} lg={12} xl={4} as="dt">Смърт и трайно намалена работоспособност</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmount amount={offer.applicationTravelAssistance?.deathPermanentDisability}/>
                </Col>
            </>}
            {offer.applicationTravelAssistance?.hospitalStay && <>
                <Col sm={4} lg={12} xl={4} as="dt">Дневни пари за болничен престой</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmount amount={offer.applicationTravelAssistance?.hospitalStay}/>
                </Col>
            </>}
            {offer.applicationTravelAssistance?.personalLuggage && <>
                <Col sm={4} lg={12} xl={4} as="dt">Кражба, загуба или забавяне на личен багаж</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmount amount={offer.applicationTravelAssistance?.personalLuggage}/>
                </Col>
            </>}
            {offer.applicationTravelAssistance?.documentsProtection && <>
                <Col sm={4} lg={12} xl={4} as="dt">Разходи за откраднати/изгубени документи</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmount amount={offer.applicationTravelAssistance?.documentsProtection}/>
                </Col>
            </>}
            {offer.applicationTravelAssistance?.thirdPartiesLiability && <>
                <Col sm={4} lg={12} xl={4} as="dt">Гражданска отговорност към трети лица</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmount amount={offer.applicationTravelAssistance?.thirdPartiesLiability}/>
                </Col>
            </>}
            {offer.applicationTravelAssistance?.legalAid && <>
                <Col sm={4} lg={12} xl={4} as="dt">Правна помощ</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmount amount={offer.applicationTravelAssistance?.legalAid}/>
                </Col>
            </>}
            {offer.applicationTravelAssistance?.flightPackage  === true && <>
                <Col sm={4} lg={12} xl={4} as="dt">Пакет „Полет”</Col>
            {offer.insuranceCompany?.number !== 8 ?
                <Col sm={8} lg={12} xl={8} as="dd" className='text-red'>Важи само за ЗК Дженерали</Col> :
            <Col sm={8} lg={12} xl={8} as="dd"><PremiumAmount amount='550'/></Col>
            }</>}
            {offer.applicationTravelAssistance?.onTheWayPackage  === true && <>
                <Col sm={4} lg={12} xl={4} as="dt">Пакет „На път”</Col>
            {offer.insuranceCompany?.number !== 8 ?
                <Col sm={8} lg={12} xl={8} as="dd" className='text-red'>Важи само за ЗК Дженерали</Col> :
                <Col sm={8} lg={12} xl={8} as="dd"><PremiumAmount amount='275'/></Col>
            }</>}
            {offer.installments && <>
                <Col sm={4} lg={12} xl={4} as="dt">Обща дължима премия</Col>
                <Col sm={8} lg={12} xl={8} as="dd">
                    <PremiumAmountSum arr={offer.installments} field="totalAmount" />
                </Col>
            </>}
        </Row>}
    </>);
};

export default TravelAssistanceOfferInfoWidget;
